<template>
  <FilterSingleChip
    is-text
    :label="label || $t('search-filters.closing-before.name')"
    :items="items"
    :value="value || null"
    @change="$emit('change', $event)"
  />
</template>

<script>
import FilterSingleChip from '@/components/filters/FilterSingleChip';
import { CLOSING_BEFORE, CLOSING_BEFORE_VALUES } from '@/models/search-filters';

/**
 * Closing-before dimension chip. Presentational: `:value` (enum string) in, `change` out.
 * Builds its option list from CLOSING_BEFORE_VALUES + i18n. Reusable across pages.
 */
export default {
  name: 'ClosingChip',
  components: { FilterSingleChip },
  props: {
    value: { type: String, default: null },
    // Optional label override (defaults to the shared closing-before label).
    label: { type: String, default: null },
  },
  computed: {
    items() {
      return CLOSING_BEFORE_VALUES.map((value) => ({
        value,
        text: this.$t(`search-filters.closing-before.values.${value}`),
        // "Anytime" means anytime in the future — keep the clarifying sublabel from the legacy filter.
        subtitle: value === CLOSING_BEFORE.ANY_TIME ? this.$t('search-filters.closing-before.futur-suffix') : '',
      }));
    },
  },
};
</script>
